import React, { useState } from 'react'

import { Row, Button, Statistic, Divider, Space } from 'antd'
import { PlusOutlined } from '@ant-design/icons'

import LQAList from '../../../../components/lqa/list'
import FormLqa from '../lqa/form'
import FormLqaComment from '../lqa/comment/form'

import {
  useQACreate,
  useQAUpdate,
  useQARemove,
  useQAUploadScorecard,
  useQADownloadScorecard,
  useQARemoveScorecard,
  useQACreateComment,
  useQARemoveComment
} from '../../../../hooks/manager/job'

const ShowLQA = (props) => {
  const { qas, jobDto, job } = props
  const { id } = jobDto

  const [lqa, setLqa] = useState(null)
  const [modalLqaVisible, setModalLqaVisible] = useState(false)
  const [modalLqaCommentVisible, setModalLqaCommentVisible] = useState(false)

  // QA Crud
  const { mutate: createQA, isLoading: isCreateLoading } = useQACreate(id)
  const { mutate: updateQA, isLoading: isUpdateLoading } = useQAUpdate(id)
  const { mutate: removeLqa, isLoading: isRemoveLoading } = useQARemove(id)

  // QA Comments crud
  const { mutate: createQAComment, isLoading: isCreateCommentLoading } = useQACreateComment(id)
  const { mutate: removeQAComment, isLoading: isRemoveCommentLoading } = useQARemoveComment(id)

  // QA Scorecard crud
  const { mutate: uploadScorecard, isLoading: isUploadScorecardLoading } = useQAUploadScorecard(id)
  const { mutate: downloadScorecard, isLoading: isDownloadScorecardLoading } = useQADownloadScorecard(id)
  const { mutate: removeScorecard, isLoading: isRemoveScorecardLoading } = useQARemoveScorecard(id)

  const actionLoading = isRemoveLoading || isCreateCommentLoading || isCreateLoading || isUpdateLoading || isRemoveCommentLoading || isUploadScorecardLoading || isDownloadScorecardLoading || isRemoveScorecardLoading
  const submitQa = lqa === null ? createQA : updateQA

  const vendorsId = (job.tasks || []).filter((item) => item.vendor && item.vendor.id).map((item) => item.vendor.id)
  const vendors = props.vendors.filter((item) => vendorsId.indexOf(item?.id) !== -1)

  const isModalActive = modalLqaVisible || modalLqaCommentVisible

  const onModalComment = (record) => {
    setLqa(record)
    setModalLqaCommentVisible(true)
  }
  const onModalEdit = (record) => {
    setLqa(record)
    setModalLqaVisible(true)
  }

  return (
    <>
      <div style={{ padding: 10 }} className='pull-right'>
        <Button
          size='small'
          type='primary'
          icon={<PlusOutlined />}
          onClick={() => setModalLqaVisible(true)}
          disabled={isModalActive}
          loading={isModalActive}
        >
          New LQA
        </Button>
      </div>

      <Row justify='end'>
        <Space style={{ paddingLeft: 20 }}>
          <Statistic title='Internal' suffix='%' value={jobDto.score_lqa_internal} />
          <Divider type='vertical' />
          <Statistic title='Client' suffix='%' value={jobDto.score_lqa_client} />
          <Divider type='vertical' />
          <Statistic title='External' suffix='%' value={jobDto.score_lqa_external} />
          <Divider type='vertical' />
        </Space>
      </Row>

      <LQAList
        lqas={qas || []}
        allowEdit
        onModalEdit={onModalEdit}
        onModalComment={onModalComment}
        isModalActive={isModalActive}
        removeLqa={removeLqa}
        removeLqaComment={removeQAComment}
        actionLoading={actionLoading}
        removeScorecard={removeScorecard}
        uploadScorecard={uploadScorecard}
        downloadScorecard={downloadScorecard}
      />

      {modalLqaVisible && (
        <FormLqa
          onCancel={() => {
            setModalLqaVisible(false)
            setLqa(null)
          }}
          submitQa={submitQa}
          qa={lqa}
          vendors={vendors}
        />
      )}
      {modalLqaCommentVisible && (
        <FormLqaComment
          onCancel={() => {
            setModalLqaCommentVisible(false)
            setLqa(null)
          }}
          createQAComment={createQAComment}
          qaId={lqa.id}
        />
      )}
    </>
  )
}

export default ShowLQA
